import Grid from '@mui/material/Grid';
import React from 'react';
import AWSIcon from '../components/CustomIcons/AWSIcon';
import AzureIcon from '../components/CustomIcons/AzureIcon';
import CSharpIcon from '../components/CustomIcons/CSharpIcon';
import JavascriptIcon from '../components/CustomIcons/JavascriptIcon';
import MySqlIcon from '../components/CustomIcons/MySqlIcon';
import PHPIcon from '../components/CustomIcons/PHPIcon';
import PostgreSQLIcon from '../components/CustomIcons/PostgreSQLIcon';
import SQLServerIcon from '../components/CustomIcons/SQLServerIcon';
import TypeScriptIcon from '../components/CustomIcons/TypeScriptIcon';
import SkillsCard from '../components/SkillsCard/SkillsCard';
import skillSetList from '../data/skillSetList.json';

const itemSize = 4;

const iconMap = {
  aws: <AWSIcon sx={{ fontSize: 32, color: 'white' }} />,
  azure: <AzureIcon sx={{ fontSize: 32 }} />,
  csharp: <CSharpIcon sx={{ fontSize: 32, color: 'white' }} />,
  javascript: <JavascriptIcon sx={{ fontSize: 32 }} />,
  mysql: <MySqlIcon sx={{ fontSize: 32 }} />,
  php: <PHPIcon sx={{ fontSize: 32, color: 'white' }} />,
  postgresql: <PostgreSQLIcon sx={{ fontSize: 32 }} />,
  sqlserver: <SQLServerIcon sx={{ fontSize: 32, color: 'white' }} />,
  typescript: <TypeScriptIcon sx={{ fontSize: 32 }} />,
} as const;

type SkillSetItem = {
  icon: keyof typeof iconMap;
  title: string;
  description: string;
};

function SkillSetList() {
  return (
  <Grid container spacing={1} justifyContent="space-around">
    {(skillSetList as SkillSetItem[]).map((item) => 
      <Grid item md={itemSize} key={item.title}>
        <SkillsCard 
          icon={iconMap[item.icon]}
          description={item.description}
          title={item.title}
          />
      </Grid>
    )}
  </Grid>
  )
}

export default SkillSetList;